var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M7.736,7.624,2.674,8.36l3.663,3.57-.865,5.041L10,14.59l4.527,2.38-.865-5.041,3.663-3.57-5.062-.736L10,3.037Z",
    style: {
      fill: "#f1d000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M6.352,11.94v-.017l-.012-.012L2.71,8.37l5.02-.729h.017l.008-.015L10,3.074l2.246,4.549.008.015h.017l5.021.729-3.634,3.544-.012.012v.017l.858,5-4.489-2.36L10,14.572l-.015.008L5.5,16.941ZM10,3,7.726,7.609,2.64,8.348l3.68,3.587L5.451,17,10,14.608,14.549,17l-.869-5.065,3.68-3.587-5.085-.739Z",
    style: {
      fill: "#f1d000"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxStar);
export default __webpack_public_path__ + "static/media/bxStar.c12c9ca6ad967c4b7facd20412be45a4.svg";
export { ForwardRef as ReactComponent };